(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-buy-box"] && !Shopify.designMode) return;
  try {
    
  /* Buy box: keeps the hidden variant/quantity inputs, the button label,
     the saving figure and the shipping bar in step with the selected tier. */
  (function () {
    document.querySelectorAll('[data-nv-buybox]').forEach(function (box) {
      var form = box.querySelector('[data-nv-buyform]');
      if (!form) return;

      var variantInput = form.querySelector('[data-nv-variant]');
      var qtyInput = form.querySelector('[data-nv-qty]');
      var submitLabel = form.querySelector('[data-nv-submit-label]');
      var subscribe = form.querySelector('[data-nv-subscribe]');
      var shipLabel = box.querySelector('[data-nv-ship-label]');
      var shipFill = box.querySelector('[data-nv-ship-fill]');
      var threshold = parseInt(box.getAttribute('data-threshold') || '0', 10);
      var baseLabel = submitLabel ? submitLabel.textContent.trim() : 'Add to cart';

      function money(cents) {
        return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
      }

      function sync() {
        var tier = form.querySelector('.nv-tier__input:checked');
        if (!tier) return;

        variantInput.value = tier.value;
        qtyInput.value = tier.getAttribute('data-quantity');

        if (submitLabel) {
          var verb = subscribe && subscribe.checked ? 'Subscribe' : baseLabel;
          submitLabel.textContent = verb + ' · ' + tier.getAttribute('data-label') + ' · ' + tier.getAttribute('data-price');
        }

        if (shipLabel && shipFill && threshold > 0) {
          var total = parseInt(tier.getAttribute('data-total') || '0', 10);
          var pct = Math.min(100, (total / threshold) * 100);
          shipFill.style.width = pct + '%';
          if (total >= threshold) {
            shipLabel.textContent = 'This order ships free';
            box.setAttribute('data-ship-met', 'true');
          } else {
            shipLabel.textContent = money(threshold - total) + ' away from free shipping';
            box.setAttribute('data-ship-met', 'false');
          }
        }
      }

      form.addEventListener('change', sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-lp-announcement"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot(bar) {
    var clock = bar.querySelector('[data-nv-countdown]');
    if (!clock) return;
    var endAttr = (bar.dataset.countdownEnd || '').trim();
    var hours = parseFloat(bar.dataset.countdownHours || '0');
    var end;
    if (endAttr) {
      end = new Date(endAttr).getTime();
      if (isNaN(end)) end = null;
    }
    if (!end && hours > 0) {
      // Rolling countdown, persisted per visitor.
      var key = 'nv-lp-countdown';
      var stored = parseInt(window.localStorage.getItem(key) || '0', 10);
      if (!stored || stored < Date.now()) {
        stored = Date.now() + hours * 3600 * 1000;
        window.localStorage.setItem(key, String(stored));
      }
      end = stored;
    }
    if (!end) return;
    clock.hidden = false;
    var h = clock.querySelector('[data-nv-h]');
    var m = clock.querySelector('[data-nv-m]');
    var s = clock.querySelector('[data-nv-s]');
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      h.textContent = pad(Math.floor(left / 3600));
      m.textContent = pad(Math.floor(left / 60) % 60);
      s.textContent = pad(left % 60);
      if (left === 0) clearInterval(timer);
    };
    tick();
    var timer = setInterval(tick, 1000);
  }
  document.querySelectorAll('.nv-lp-bar').forEach(boot);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.nv-lp-bar').forEach(boot);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-lp-attributes"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot(root) {
    var tiles = root.querySelectorAll('[data-nv-attr-tile]');
    var panels = root.querySelectorAll('[data-nv-attr-panel]');
    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        var id = tile.getAttribute('data-nv-attr-tile');
        tiles.forEach(function (t) { t.classList.toggle('is-active', t === tile); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-nv-attr-panel') === id); });
      });
    });
  }
  document.querySelectorAll('[data-nv-attrs]').forEach(boot);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-nv-attrs]').forEach(boot);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-lp-buy"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot(form) {
    var priceEl = form.querySelector('[data-nv-cta-price]');
    var labelEl = form.querySelector('[data-nv-cta-label]');
    if (!priceEl) return;
    // Read from the data attribute, never from the label's own text: after a
    // section re-render the label already reads "Buy now - 10% off", so
    // re-capturing it appends the suffix again on every reload.
    var base = labelEl ? (labelEl.dataset.ctaBase || labelEl.textContent.trim()) : '';
    // The button shows the GROSS line total and lets the cart do the
    // discounting. Measured 12 Oct 2026: the three volume tiers are
    // cumulative with each other AND with NUTRA10, so six units came to 40%
    // off, not 15%. Until that is settled, any total computed here would be
    // a number the cart contradicts, so the page quotes none.
    function lineTotal(unitCents, qty) {
      return unitCents * qty;
    }
    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    // The button names the volume tier the current quantity actually earns,
    // so "BUY NOW - 10% OFF" is only ever shown when the cart will apply 10%.
    // Tiers come from the same data-tiers the progress bar reads.
    function tierOffFor(qty) {
      var bar = document.querySelector('[data-nv-tierbar]');
      if (!bar) return 0;
      var best = 0;
      (bar.dataset.tiers || '').split('|').forEach(function (t) {
        var b = t.split(':');
        var q = parseInt(b[0], 10), o = parseInt(b[1], 10);
        if (q > 0 && qty >= q && o > best) best = o;
      });
      return best;
    }

    function sync() {
      var checked = form.querySelector('input[name="id"]:checked');
      if (!checked) return;
      // The option markup comes from nv-b8-option, so the hook is
      // [data-nv-opt], not the old [data-nv-variant].
      var card = checked.closest('[data-nv-opt]');
      if (!card) return;
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
      var unit = parseInt((card.dataset.price || '0').replace(/[^0-9]/g, ''), 10);
      priceEl.textContent = qty > 1
        ? money(lineTotal(unit, qty))
        : (card.dataset.price || '');
      // Per-serve is the comparison that sells the bigger pack. It is a rate,
      // so it does not scale with quantity.
      // The pack shot above the list follows the selected row. The selected
      // option is `card` in this section, not `opt` — referencing the wrong
      // one threw before the per-serve was set, so BOTH the image and the
      // per-serve silently stopped updating.
      var mainImg = form.querySelector('[data-nv-main-img]');
      if (mainImg && card.dataset.img) { mainImg.src = card.dataset.img; mainImg.alt = card.dataset.name || ''; }
      var unitEl = form.querySelector('[data-nv-cta-unit]');
      if (unitEl) unitEl.textContent = card.dataset.unit || '';
      if (labelEl) {
        // See the schema note: the per-serve saving is not money off the
        // price, so naming it on the button is opt-in.
        var dynamic = form.dataset.ctaDynamic === 'true';
        var save = parseInt(card.dataset.save, 10);
        var off = tierOffFor(qty);
        if (off > 0) labelEl.textContent = base + ' \u2014 ' + off + '% off';
        else if (dynamic && save > 0) labelEl.textContent = 'Save ' + save + '% off';
        else labelEl.textContent = base;
      }
    }
    form.addEventListener('change', function (e) {
      if (e.target.name === 'id' || e.target.name === 'quantity') sync();
    });
    sync();
  }

  // Quantity stepper and volume-tier progress, as ONE delegated controller.
  //
  // Nothing here binds to a node. `shopify theme dev` hot reload and the theme
  // editor both replace a section's markup wholesale, which silently destroys
  // every listener attached at load: the +/- buttons go dead and the bar
  // freezes while typing in the number field still changes the digit. Listening
  // on `document` and looking the elements up per event survives any re-render.
  (function () {
    if (window.__nvB8QtyCtl) return;
    window.__nvB8QtyCtl = true;

    function clamp(v) { return Math.max(1, Math.min(99, parseInt(v, 10) || 1)); }

    // A page can carry more than one buy box, so every lookup stays inside the
    // control's own form rather than reaching for the first match in the page.
    function scopeOf(el) {
      return (el && el.closest && el.closest('form')) || document;
    }

    function paint(scope) {
      if (!scope) return;
      var bar = scope.querySelector('[data-nv-tierbar]');
      var qi = scope.querySelector('[data-nv-qty-input]');
      if (!bar || !qi) return;
      var tiers = (bar.dataset.tiers || '').split('|').map(function (t) {
        var b = t.split(':');
        return { qty: parseInt(b[0], 10), off: parseInt(b[1], 10) };
      }).filter(function (t) { return t.qty > 0; }).sort(function (a, b) { return a.qty - b.qty; });
      if (!tiers.length) return;

      var top = tiers[tiers.length - 1];
      var fill = bar.querySelector('[data-nv-tierfill]');
      var msg = bar.querySelector('[data-nv-tiermsg]');
      var steps = bar.querySelectorAll('[data-nv-tierstep]');
      var q = clamp(qi.value);
      var earned = null, next = null;
      for (var i = 0; i < tiers.length; i++) {
        if (q >= tiers[i].qty) earned = tiers[i];
        else if (!next) next = tiers[i];
      }
      if (fill) fill.style.width = Math.min(100, (q / top.qty) * 100) + '%';
      for (var s = 0; s < steps.length; s++) {
        steps[s].classList.toggle('is-on', q >= parseInt(steps[s].dataset.qty, 10));
      }
      if (!msg) return;
      if (!earned && next) {
        var need = next.qty - q;
        msg.textContent = 'Add ' + need + (need === 1 ? ' more pack' : ' more packs') + ' and save ' + next.off + '%';
      } else if (earned && next) {
        var need2 = next.qty - q;
        msg.textContent = earned.off + '% off unlocked. Add ' + need2 + (need2 === 1 ? ' more pack' : ' more packs') + ' for ' + next.off + '%';
      } else {
        // "the biggest volume saving" only means something against a ladder.
        msg.textContent = earned.off + '% off unlocked' + (tiers.length > 1 ? ', the biggest volume saving.' : '.');
      }
    }

    function paintAll() {
      var bars = document.querySelectorAll('[data-nv-tierbar]');
      for (var i = 0; i < bars.length; i++) paint(scopeOf(bars[i]));
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var up = e.target.closest('[data-nv-qty-up]');
      var dn = up ? null : e.target.closest('[data-nv-qty-down]');
      if (!up && !dn) return;
      var scope = scopeOf(up || dn);
      var qi = scope.querySelector('[data-nv-qty-input]');
      if (!qi) return;
      e.preventDefault();
      qi.value = clamp((parseInt(qi.value, 10) || 1) + (up ? 1 : -1));
      // Bubbles so the section's own price/CTA sync hears it too.
      qi.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Paint on input so the bar tracks typing; only clamp on change, because
    // clamping mid-keystroke fights anyone typing a two-digit quantity.
    document.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-nv-qty-input]')) paint(scopeOf(e.target));
    });
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches || !e.target.matches('[data-nv-qty-input]')) return;
      e.target.value = clamp(e.target.value);
      paint(scopeOf(e.target));
    });

    document.addEventListener('shopify:section:load', paintAll);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintAll);
    else paintAll();
  })();

  document.querySelectorAll('[data-nv-buy]').forEach(boot);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-nv-buy]').forEach(boot);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-lp-expect"] && !Shopify.designMode) return;
  try {
    
(function () {
  function draw(card, series) {
    var vals = String(series || '').split(',').map(function (v) { return parseFloat(v.trim()); }).filter(function (v) { return !isNaN(v); });
    if (!vals.length) return;
    var step = vals.length > 1 ? 320 / (vals.length - 1) : 320;
    var pts = vals.map(function (v, i) {
      return (i * step).toFixed(1) + ',' + (150 - Math.max(0, Math.min(100, v)) / 100 * 128).toFixed(1);
    }).join(' ');
    card.querySelector('[data-nv-line]').setAttribute('points', pts);
    card.querySelector('[data-nv-area]').setAttribute('points', '0,150 ' + pts + ' 320,150');
  }
  function boot(card) {
    var tabs = card.querySelectorAll('[data-nv-tab]');
    var panels = card.querySelectorAll('[data-nv-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-nv-tab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-nv-panel') === id); });
        draw(card, tab.dataset.series);
      });
    });
    var active = card.querySelector('.nv-lp-expect__tab.is-active') || tabs[tabs.length - 1];
    if (active) draw(card, active.dataset.series);
  }
  document.querySelectorAll('[data-nv-expect]').forEach(boot);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-nv-expect]').forEach(boot);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-pdp-buy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-nv-pdp]').forEach(function (root) {
      if (root.dataset.nvBound) return;
      root.dataset.nvBound = '1';

      var atc = root.querySelector('[data-nv-atc]');
      var atcText = root.querySelector('[data-nv-atc-text]');
      var tiers = root.querySelectorAll('.nv-tier');

      function selected() { return root.querySelector('.nv-tier__in:checked'); }

      function sync() {
        tiers.forEach(function (t) {
          var input = t.querySelector('.nv-tier__in');
          t.classList.toggle('is-active', !!(input && input.checked));
        });
        var s = selected();
        if (s && atcText && atc && atc.dataset.nvLabel) {
          atcText.textContent = atc.dataset.nvLabel + ' — ' + (s.dataset.nvPrice || '');
        }
      }

      tiers.forEach(function (t) {
        t.addEventListener('change', sync);
        t.addEventListener('click', function () {
          var input = t.querySelector('.nv-tier__in');
          if (input && !input.checked) { input.checked = true; sync(); }
        });
      });

      root.querySelectorAll('[data-nv-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var main = root.querySelector('.nv-pdp__img');
          if (main && btn.dataset.nvThumb) { main.src = btn.dataset.nvThumb; main.removeAttribute('srcset'); }
          root.querySelectorAll('[data-nv-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });

      function getDrawer() { return document.querySelector('cart-drawer'); }

      /* Mirror the theme's own product-form: ask the drawer which sections it
         intends to re-render and request exactly those. Requesting fewer makes
         Dawn's renderContents throw on the missing one. */
      function sectionIds() {
        var d = getDrawer();
        if (d && typeof d.getSectionsToRender === 'function') {
          return d.getSectionsToRender().map(function (s) { return s.id; });
        }
        return ['cart-drawer', 'cart-icon-bubble'];
      }

      function openDrawer(data) {
        var d = getDrawer();
        if (!d) return false;
        if (typeof d.renderContents === 'function' && data && data.sections) {
          try { d.renderContents(data); return true; } catch (e) {}
        }
        if (typeof d.open === 'function') { try { d.open(); return true; } catch (e) {} }
        return false;
      }

      if (atc) {
        atc.addEventListener('click', function () {
          var s = selected();
          if (!s) return;
          atc.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(s.dataset.nvVariant), quantity: Number(s.dataset.nvQty || 1) }],
              sections: sectionIds(),
              sections_url: window.location.pathname
            })
          })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data && data.status) throw data;
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              if (!openDrawer(data)) window.location.href = '/cart';
            })
            .catch(function () { window.location.href = '/cart'; })
            .then(function () { atc.disabled = false; });
        });
      }

      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-sticky-atc"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var bar = document.querySelector('[data-nv-sticky]');
      if (!bar) return;

      var watchId = bar.getAttribute('data-watch');
      var buybox = watchId ? document.getElementById(watchId) : document.querySelector('[data-nv-buybox]');
      var form = buybox ? buybox.querySelector('[data-nv-buyform]') : null;
      var title = bar.querySelector('[data-nv-sticky-title]');
      var price = bar.querySelector('[data-nv-sticky-price]');
      var addBtn = bar.querySelector('[data-nv-sticky-add]');
      var mq = window.matchMedia('(max-width: 859px)');

      function syncCopy() {
        if (!form) return;
        var tier = form.querySelector('.nv-tier__input:checked');
        if (!tier) return;
        if (title) title.textContent = tier.getAttribute('data-label');
        if (price) price.textContent = tier.getAttribute('data-price') + ' · ' + tier.getAttribute('data-per-serve') + ' a serve';
      }

      if (buybox && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          var past = !e.isIntersecting && e.boundingClientRect.bottom < 0;
          bar.hidden = !(past && mq.matches);
        }).observe(buybox);
      }

      if (form) form.addEventListener('change', syncCopy);
      if (addBtn && form) {
        addBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
      }
      mq.addEventListener('change', function () { if (!mq.matches) bar.hidden = true; });
      syncCopy();
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv8-sticky-pill"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var pill = document.querySelector('[data-nv-pill]');
    if (!pill) return;
    var show = function () { pill.hidden = window.scrollY < 400; };
    window.addEventListener('scroll', show, { passive: true });
    show();
  })();

  } catch(e) { console.error(e); }
})();
})();
